import { useEffect, useRef } from 'react';
import { useWelcomeResumePrompt } from '../hooks/useWelcomeResumePrompt';

/**
 * Auto-abre o Welcome Wizard (tela cheia) quando a conta caiu no Admin sem ter
 * passado pelo Welcome (isNewUser flipou p/ false num 2º login) e está 100%
 * vazia. Antes isto era um banner soft ("Retomar assistente"); virou auto-launch
 * por decisão de produto (2026-07-21) — conta estritamente vazia deve cair direto
 * no onboarding, que é o único caminho que também cria os sites públicos.
 *
 * Redireciona para /?newuser=true: o gate do App.jsx reconhece o parâmetro, limpa
 * a sessão de welcome e renderiza o <WelcomeWizard/> em tela cheia (Step0→Step10).
 * IMPORTANTE: reload real (window.location), NÃO o navigate do react-router — a
 * detecção de newuser roda no mount effect do App.jsx e não reage a navegação SPA.
 *
 * NÃO confundir com o wizard de "criar local" (/places?wizard=1, PlaceCreationWizard):
 * aquele é criação manual dinâmica e NÃO gera as páginas públicas do onboarding.
 *
 * Escape hatch anti-loop: o próprio wizard tem "Pular configuração", que grava
 * completedAt em agendario_welcome_session → a conta deixa de ser elegível e o
 * auto-launch não redispara. Por isto NÃO auto-abrimos em erro de carga (errored):
 * stats fica no default zerado e um usuário não-vazio seria jogado no wizard.
 *
 * @param {{ stats: object, loading: boolean, errored?: boolean }} props
 */
export default function WelcomeResumeBanner({ stats, loading, errored = false }) {
  const { eligible } = useWelcomeResumePrompt({ stats, loading });
  const firedRef = useRef(false);

  useEffect(() => {
    if (eligible && !errored && !firedRef.current) {
      firedRef.current = true;
      window.location.href = '/?newuser=true';
    }
  }, [eligible, errored]);

  return null;
}
